export default __webpack_public_path__ + "static/media/1935.0bcb92cd.png";